import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    boxForm: {
        margin: theme.spacing(-2),
        backgroundColor: '#FFF',
        padding: theme.spacing(2),
        marginBottom: 0
    }
}))